export const KAKAO_CHANNEL_PUBLIC_ID = '_HxfMrG'

export const KAKAO_POSTCODE_SCRIPT_URL = 'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'

export const EXTERNAL_URLS = {
  LEARNING_CONSULTATION: 'https://forms.gle/JwYbLQWpxBsXiD469',
  LEARNING_GUIDE: 'https://podospeaking.com/user-guide?external=true',
  JP_LEARNING_GUIDE: 'https://podospeaking.com/jp/krlessonguide?external=true',
  KAKAO_CHANNEL_FRIEND: `https://pf.kakao.com/${KAKAO_CHANNEL_PUBLIC_ID}/friend`,
} as const
